import { useContext, useMemo } from 'react'

import { ApplicationContext } from '../../contexts'

export function useApplicationVariants() {
  const { variants = {} } = useContext(ApplicationContext)

  return useMemo(() => variants, [variants])
}

export function useApplicationVariantKey(origin, key, defaultValue = null) {
  const variants = useApplicationVariants()

  const variantKeyValue = variants[origin]?.[key] ?? defaultValue

  return useMemo(() => variantKeyValue, [variantKeyValue])
}
